import { createNaturalDivisionTask, randInt, zerosDivisionExplanation } from "./sharedNaturalDivision";

function pickData() {
  const reducedB = randInt(2, 9);
  const result = randInt(12, 49);
  const reducedA = reducedB * result;
  const zeroFactor = 10 ** randInt(1, 3);
  const a = reducedA * zeroFactor;
  const b = reducedB * zeroFactor;
  return { a, b, reducedA, reducedB, result };
}

const mod = createNaturalDivisionTask({
  type: "NaturalDivWithZerosTask",
  pickData,
  explain: zerosDivisionExplanation,
});

export const generateTask = mod.generateTask;
export const renderTask = mod.renderTask;
export const renderInput = mod.renderInput;
export const checkAnswer = mod.checkAnswer;
export const renderAnswer = mod.renderAnswer;
export const renderUserAnswer = mod.renderUserAnswer;
export const renderExplanation = mod.renderExplanation;
